import { useState, useEffect } from "react";
import type { NewsItem } from "@/types/news.types";
import { getNewsDetail } from "@/api/news.api";

export interface UseNewsDetailResult {
  news: NewsItem | null;
  isLoading: boolean;
  error: Error | null;
}

export function useNewsDetail(id: number | null): UseNewsDetailResult {
  const [news, setNews] = useState<NewsItem | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (id === null) {
      setNews(null);
      return;
    }
    let cancelled = false;
    setIsLoading(true);
    setError(null);
    getNewsDetail(id)
      .then((data) => {
        if (!cancelled) setNews(data);
      })
      .catch((e) => {
        if (!cancelled) setError(e instanceof Error ? e : new Error(String(e)));
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [id]);

  return { news, isLoading, error };
}
